import { FC, Fragment, useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createDeviceToken, logout, setreloadCount } from 'redux/authSlice/actions';
import { Button } from 'components/common';
import { ReactComponent as Logo } from 'assets/img/logo.svg';
import { ReactComponent as Bell } from 'assets/icon/bell.svg';
import Newlogo from 'assets/img/newlogos/1.png';
import ProfilePhoto from 'assets/icon/user.svg';
import Login from 'pages/Authentication/Login';
import Signup from 'pages/Authentication/Signup';
import ForgotPassword from 'pages/Authentication/ForgotPassword';
import { RootState } from 'redux/rootReducer';
import { firebaseVapidKey, messaging, onMessageListener } from 'services/firebase-config';
import { getToken } from 'firebase/messaging';
import PopOver from './PopOver';
import MenuComponent from './MenuComponent';
import NotificationComponent from './NotificationComponent';
import ApprovedModal from '../Modal/ApprovedModal';
import { setIsApprovedBooking } from 'redux/booking/action';
import bookingService from 'services/bookingService';
import { SetCurrentProductType } from 'redux/productSlice/actions';
import { simpleProductTypes } from 'utils/products';
import ComplaintModal from 'pages/UserProfile/ComplaintModal';
import mobileIcon from "../../../assets/icon/mobile.svg";

import { getSession, storage } from 'utils';
import Chatbot from '../Chatbot';
import { NotificationServices } from 'services/notificationService';
import dataService from 'services/appData';
import axios from 'axios';
import { loadingStart, loadingStopped, loginSuccess } from 'redux/authSlice/reducers';
import authService from 'services/authService';
import {
    ToastContextType,
    useToast,
  } from 'components/common/Toast/ToastProvider';
import queryString from 'query-string';
import { openInNewTab } from 'utils/openInNewTab';
import { IoLogoWhatsapp } from 'react-icons/io';

interface HeaderProps {
    isAuthenticated?: boolean;
    setMyFilter?: (arg0: any) => void;
    myFilter?: any;
}

const Header: FC<HeaderProps> = ({ isAuthenticated, setMyFilter, myFilter }: HeaderProps) => {
    const { isApprovedBookingExist } = useSelector((state: RootState) => state.booking);
    const { reloadCount } = useSelector((state: RootState) => state.user);
    const [openLogin, setOpenLogin] = useState(false);
    const [openSignup, setOpenSignup] = useState(false);
    const [openForgotPassword, setOpenForgotPassword] = useState(false);
    const [open, setOpen] = useState(false);
    const { user } = useSelector((state: RootState) => state.user);
    const [isTokenFound, setTokenFound] = useState(false);
    const [show, setShow] = useState(false);
    const [notification, setNotification] = useState({ title: '', body: '' });
    const [singleBookingData, setsingleBookingData] = useState({});
    const [notificationData, setNotificationData] = useState([]);
    const [partnerClient, setPartnerClient] = useState([]);
    const [notificationLength, setNotificationLength] = useState(0);
    const [localNotificationLength, setLocalNotificationLength] = useState(localStorage.getItem('not') || 0);
    const dispatch: any = useDispatch();
    const navigate = useNavigate();
    const [Filter, setFilter] = useState({});
    const [headerToken, setHeaderToken] = useState('');

    const toast= useToast();
    const { auto } = queryString.parse(window.location.search);

    const fetchUserNotification = async () => {
        try {
            const response = await NotificationServices.getAllNotificationByUserId(user?.userID);
            const res = response.data.sort((p1: any, p2: any) => {
                return new Date(p2.dateCreated).getTime() - new Date(p1.dateCreated).getTime();
            });
            let returnedData = res.filter((item: any) => item.status == 'unread');
            setNotificationData(returnedData);
            setNotificationLength(returnedData.length);
        } catch (err) {}
    };

    const fetchAllPartnerClient = async () => {
        try {
            const response = await dataService.getAllPartnerClient();
            // const res = response.data.sort((p1: any, p2: any)=>{
            //   return new Date (p2.createdDate).getTime()  - new Date (p1.createdDate).getTime()
            // })
            const res = response.data;
            setPartnerClient(res.filter((item: any) => item.status !== 'INACTIVE'));
        } catch (err) {}
    };

    const extractMtnToken = () => {
        axios
            .get('https://auraweb.azurewebsites.net/')
            // .get('http://localhost:3002/')
            .then((response) => {
                // Access the response headers
                const headers = response.headers;

                // Extract the JWT token from the Authorization header
                const token: any = headers.authorization; // or headers['authorization']
                const defaultToken = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IkFEbFBhd0RmNVloTEtsMGYxV1gyNSJ9.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.Na9-q7iyU2Lv88W15dPeqGCArzJqInkarjbvYJiATSvcm6zqVrE7wmaRVMMqo8sRYcEHH-B1DYP7_-704BgQPOLJiX5ZqUql8J0K7R9A0-Tvolsgnr6UdJXC2YTvmrkLpe7BLD8fr28D47ofvOSYnUE44PgtoyZ-GgEm1MU6g9qW1voemzKesKnsLLvNc9mnL6uMpHjl41WmtJygpUtPgPY-mCX3LyrF83Dp_pSkY3csdLUmINOIlxLxXB_R0bIqviW5341HoZxAxuE4mt3k6SpfjUA6Pk1vDXoR2fBSswbovzbP4vktaZuMUV1gpUAdAdXYchTL0ECRyE4DrZgTlA'
                setHeaderToken(token);
            })
            .catch((error) => {
            });
    };

    const sendMTNToken = async () => {
        const data = {
            emailAddress: auto,
        };
        try {
            const response = await dataService.postMTNToken(data);
            if(response){
            try {
                dispatch(loadingStart());
                storage.setToken(response.data.accessToken);
                const user = await authService.fetchUserDetails();
                storage.setUserId(user?.data.userID);
                dispatch(loginSuccess(user.data));
                const url = new URL(window.location.href);
                const nextRoute = url.searchParams.get('redirect') || '/';
                navigate(nextRoute, {
                  replace: true,
                });
              } catch (err: any) {
                // dispatch(ProductLoadingStop(err.response.data.responseMessage));
                toast?.error(err.response?.data.responseMessage, 5000);
                dispatch(loadingStopped(err.response?.data.responseMessage));
          
                // if(err.response?.data.responseMessage == 'You are yet to confirm your email') return setResend(true)
              }
            }
        } catch (err) {}
    };

    useEffect(() => {
        fetchUserNotification();
    }, [user?.userID]);

    useEffect(() => {
        fetchAllPartnerClient();
    }, []);

    useEffect(() => {
       !user.userID && auto && sendMTNToken();
    }, [auto]);
 
     useEffect(()=>{
         !getSession(storage.getToken()) && user.userID &&  dispatch(logout(navigate))
     },[])

    const getTokenFn: any = (setTokenFound: (arg0: boolean) => void) => {
        return getToken(messaging, { vapidKey: firebaseVapidKey })
            .then(async (currentToken: any) => {
                if (currentToken) {
                    // console.log('current token for client: ', currentToken);
                    await dispatch(
                        createDeviceToken({
                            email: user.emailAddress,
                            deviceToken: currentToken,
                        })
                    );
                    setTokenFound(true);

                    // Track the token -> client mapping, by sending to backend server
                    // show on the UI that permission is secured
                } else {
                    console.log('No registration token available. Request permission to generate one.');
                    setTokenFound(false);
                    // shows on the UI that permission is required
                }
            })
            .catch((err: any) => {
                console.log('An error occurred while retrieving token. ', err);
                // catch error while creating client token
            });
    };

    const checkBookingApproved = async () => {
        try {
            const res = await bookingService.getBookingsByProductID(29, null, null, 'approved');
            let isApprovedBookingExist = (res.data || []).length > 0;

            if (isApprovedBookingExist) {
                setsingleBookingData(res?.data[0]);
                dispatch(setIsApprovedBooking(true));
            } else {
                dispatch(setIsApprovedBooking(false));
            }
            // console.log('isApprovedBookingExist', isApprovedBookingExist);
        } catch (err) {}
    };

    //FUNCTIONS THAT SHOULD ONLY BE RUN ONCE ON LOADING / RELOAD;
    useEffect(() => {
        let isCancelled = false;
        if (!isCancelled) {
            getTokenFn(setTokenFound);
            dispatch(setreloadCount(reloadCount + 1));
        }
        return () => {
            isCancelled = true;
        };
    }, []);

    useEffect(() => {
        let isCancelled = false;
        if (!isCancelled) {
            checkBookingApproved();
            if (isApprovedBookingExist) {
                dispatch(setIsApprovedBooking(true));
                if (reloadCount <= 1 && isAuthenticated) {
                    setShow(true);
                } else {
                    setShow(false);
                }
            }
        }
        return () => {
            isCancelled = true;
        };
    }, [isApprovedBookingExist, isAuthenticated]);

    useEffect(() => {
        let isCancelled = false;

        if (!isCancelled) {
            if (isTokenFound) {
                console.log(' Notification permission enabled 👍🏻');
            } else {
                console.log(' Need notification permission ❗️ ');
            }
        }
        return () => {
            isCancelled = true;
        };
    }, [isTokenFound]);

    onMessageListener()
        .then(async (payload: any) => {
            setShow(true);
            setNotification({
                title: payload.notification.title,
                body: payload.notification.body,
            });
            // await dispatch(getnotification(payload));
            // console.log('notif payload', payload);
        })
        .catch((err) => console.log('failed: ', err));

    const [openModal1, setOpenModal1] = useState(false);

    let selectedData = {
        firstName: user?.firstName,
        lastName: user?.lastName,
        emailAddress: user?.emailAddress,
        phoneNumber: user?.phoneNumber,
    };

    const [isLoading, setisLoading] = useState(false);

    return (
        <>
            <main className="bg-white shadow sticky fit top-0 z-[10]">
                <>
                    <Login openModal={openLogin} setOpenModal={setOpenLogin} />
                    <ForgotPassword openModal={openForgotPassword} setOpenModal={setOpenForgotPassword} />
                    <Signup openModal={openSignup} setOpenModal={setOpenSignup} />
                    <ApprovedModal openModal={show} setOpenModal={setShow} singleBookingData={singleBookingData} />
                    <ComplaintModal
                        openModal={openModal1}
                        setOpenModal={setOpenModal1}
                        isLoading={isLoading}
                        setisLoading={setisLoading}
                        selectedData={selectedData}
                    />
                    <div className="md:mx-[100px] mx-[20px] py-4">
                        <div className="flex justify-between items-center mt-2 w-full">
                            <div className="lg:w-[100px] w-[80px]">
                                <Link to="/" className="inline-flex">
                                    <img src={Newlogo} className="w-100" />
                                </Link>
                            </div>
                            <div className="flex w-full items-center justify-end md:gap-6 gap-4">

                                <div className="md:flex hidden items-center">
                                    <img src={mobileIcon} alt='' className='w-[25px]'/>
                                    <Link
                                            to="#"
                                            className="text-sm flex-none text-[#040503] hover:text-auraPrimary hidden sm:flex ml-2"               
                                            onClick={() =>
                                                openInNewTab('https://play.google.com/store/search?q=aura+by+transcorp&c=apps')
                                            }
                                        >
                                            Download our app
                                        </Link>
                                </div>

                                <div className="dropdown">
                                    <button className="dropbtn text-sm hover:text-auraPrimary text-[#040503] items-center sm:flex whitespace-nowrap">
                                        Partners &nbsp;
                                        <i className="fa fa-caret-down"></i>
                                    </button>
                                    <div className="dropdown-content">
                                        {partnerClient?.map((item: any, i: number) => (
                                            <Link 
                                                key={i}
                                                to={`/partners/${item?.alias.toLowerCase()}/${item?.id}`}
                                                state={{ partnerID: item?.id }}
                                            >
                                                {item?.alias}
                                            </Link>
                                        ))}
                                    </div>
                                </div>

                                {(!isAuthenticated || !getSession(storage.getToken())) && (
                                    <>
                                        <Link
                                            to="/onboarding"
                                            className="text-sm flex-none text-[#040503] hover:text-auraPrimary hidden sm:flex"
                                        >
                                            List a Property
                                        </Link>
                                        <p
                                            className=" cursor-pointer text-sm flex-none text-[#040503] hover:text-auraPrimary sm:flex"
                                            onClick={() => setOpenLogin(true)}
                                        >
                                            Login
                                        </p>
                                        <Button
                                            type="button"
                                            variant="primary"
                                            className="flex-none py-2 md:px-8 px-4 !rounded-md"
                                            onClick={() => setOpenSignup(true)}
                                        >
                                            Register
                                        </Button>
                                    </>
                                )}

                                {isAuthenticated && getSession(storage.getToken()) && (
                                    <>
                                        {user.ishost ? (
                                            <Link
                                                to="/dashboard"
                                                className="border-2 border-gray-2 py-3 px-[18px] rounded-lg text-[#040503] hidden sm:block whitespace-nowrap"
                                            >
                                                Host Dashboard
                                            </Link>
                                        ) : (
                                            <Link
                                                to="/onboarding"
                                                className="text-sm font-medium flex-none text-[#040503] hover:text-auraPrimary hidden sm:flex"
                                            >
                                                List a Property
                                            </Link>
                                        )}

                                        <PopOver
                                            type="notification"
                                            icon={
                                                <div className="relative mr-4 md:mr-0">
                                                    {notificationLength > +localNotificationLength && (
                                                        <div className="h-3 w-3 rounded-[50%] bg-auraPrimary absolute top-[-10px] right-[-8px]" />
                                                    )}
                                                    <Bell />
                                                </div>
                                            }
                                        >
                                            <NotificationComponent
                                                notification={notification}
                                                setLocalNotificationLength={setLocalNotificationLength}
                                            />
                                        </PopOver>

                                        <PopOver
                                            type="menu"
                                            icon={
                                                <div className="inline-flex h-7 w-7 rounded-[50%] flex-none">
                                                    <img
                                                        src={ProfilePhoto}
                                                        alt="profile"
                                                        className="h-7 w-7 rounded-[50%] flex-none"
                                                    />
                                                </div>
                                            }
                                        >
                                            <MenuComponent setOpenModal1={setOpenModal1} />
                                        </PopOver>
                                    </>
                                )}
                            </div>
                        </div>
                        <div
                            className={`${
                                open ? 'h-auto sm:hidden flex flex-col w-full py-6 gap-2' : 'h-0 overflow-hidden p-0'
                            } transition-all`}
                        >
                            <Link to="/" className="bg-auraPrimary text-white px-4 py-2 rounded">
                                Home
                            </Link>
                            <Link to="/" className=" px-4 py-2 text-gray-4">
                                Support
                            </Link>
                            <Link to="/" className="px-4 py-2 text-gray-4">
                                List a Property
                            </Link>
                        </div>
                    </div>
                </>
            </main>
            {/* Chatbot chat button */}
            {/* <Chatbot /> */}

            {/* whatapp chat button */}
            <button
                className="bg-auraPrimary flex items-center justify-center rounded-full fixed h-[49px] w-[49px] bottom-[20px] right-[20px] z-40"
            >
               <IoLogoWhatsapp className='text-white text-[30px]' onClick={()=> window.open('https://wa.link/mulc9s')}/>
            </button>
        </>
    );
};

export default Header;
